import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import localforage from "localforage";
import { Helmet } from "react-helmet";
import logo from "../assets/img/logo.png";
import successLogo from "../assets/img/login.a096575bed4a20415bbe.jpg";
import { toast } from "react-toastify";
import { useUser } from "../context/UserProvider";

const Layout = ({ success = false, children }) => {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const { userData, clearUserData } = useUser();
  const location = useLocation();

  useEffect(() => {
    const checkAuth = async () => {
      const jwt = await localforage.getItem("jwt");
      setIsLoggedIn(!!jwt);
    };
    checkAuth();
  }, []);

  useEffect(() => {
    if (userData && (!userData.license_plate_number || !userData.chassis_number)) {
      if (location.pathname !== "/profile") {
        navigate("/profile");
      }
    }
  }, [userData, location.pathname, navigate]);

  const handleAuthClick = async () => {
    const jwt = await localforage.getItem("jwt");
    if (jwt) {
      await localforage.removeItem("jwt");
      navigate("/login");
      clearUserData();
      toast.success("خارج شدید.", { rtl: true });
      setIsLoggedIn(false);
    } else {
      navigate("/login");
    }
  };

  return (
    <section className="AZ-login-page position-relative">
      <Helmet>
        <title>سامانه اصالت کالا و گارانتی شرکت دینا پارت</title>
        <meta name="description" content="سامانه اصالت کالا و گارانتی شرکت دینا پارت برای پیگیری خریدها و ثبت کد جدید." />
        <meta name="keywords" content="گارانتی، اصالت کالا، شرکت دینا پارت، خرید، ثبت کد جدید" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="سامانه اصالت کالا و گارانتی شرکت دینا پارت" />
        <meta property="og:description" content="پیگیری خریدها و ثبت کد جدید در سامانه اصالت کالا و گارانتی شرکت دینا پارت." />
        <meta property="og:image" content={logo} />
        <meta property="og:url" content={window.location.href} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="سامانه اصالت کالا و گارانتی شرکت دینا پارت" />
        <meta name="twitter:description" content="پیگیری خریدها و ثبت کد جدید در سامانه اصالت کالا و گارانتی شرکت دینا پارت." />
        <meta name="twitter:image" content={logo} />
      </Helmet>

      <div className="container-fluid h-100 p-0">
        <div className="row">
          <div className="navbar-wrapper d-flex align-items-center justify-content-center justify-content-lg-end">
            <a href="/orders" className="nav-link d-flex align-items-center gap-1">
              لیست خرید های من
            </a>
            <a href="/" className="nav-link d-flex align-items-center gap-1">
              ثبت کد جدید
            </a>
            <a href="#" onClick={handleAuthClick} className="nav-link d-flex align-items-center gap-1">
              {isLoggedIn ? "خروج" : "ورود"}
            </a>
          </div>
        </div>
        <div className="row g-0 h-100">
          <div className="col-lg-3 login-right">
            <div
              className={`login-box_right d-flex flex-column ${
                success ? "justify-content-between" : "justify-content-center"
              }`}
            >
              <div>
                <div className="d-flex align-items-center justify-content-center">
                  <img src={logo} alt="logo" className="logo" />
                </div>
                <h4 className="login-title text-center">
                  سامانه اصالت کالا و گارانتی شرکت دینا پارت
                </h4>
              </div>
              {success && (
                <div className="d-flex align-items-center justify-content-center flex-grow-1">
                  <img src={successLogo} alt="success logo" width="100%" />
                </div>
              )}
            </div>
          </div>
          <div className="col-lg-9 login-left">
            <div className="login-box_left">
              <div className="login-box_left_body w-100">{children}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Layout;
